/**
 * Single source of truth for decision outcomes on the admin panel.
 *
 * Mirrors the backend's `DecisionOutcome` enum (send/skip/defer). The
 * `listRecentDecisions` validator only accepts these three values, so the
 * UI filter dropdown and the badge color helper must agree with the server.
 */

export const DECISION_OUTCOMES = ['send', 'skip', 'defer'] as const;
export type DecisionOutcome = (typeof DECISION_OUTCOMES)[number];

export function outcomeBadgeVariant(
  o: string | undefined,
): 'success' | 'warning' | 'outline' | 'destructive' | 'default' {
  if (o === 'send') return 'success';
  if (o === 'defer') return 'warning';
  if (o === 'skip') return 'outline';
  return 'default';
}
